<template>
  <div
    class="card"
    :class="[
      {
        [$props.color]: $props.color,
        [`${$props.width}Width`]: $props.width,
        [`padding-${$props.padding}`]: $props.padding,
        [`elevation-${$props.elevation}`]: $props.elevation,
        round: $props.round,
        border: $props.border,
      },
    ]"
  >
    <slot />
  </div>
</template>

<script>
/**
 * @group Base
 * Functional component, renders a card whose content is displayed in a flex column
 */
export default {
	props: {
		padding: {
			type: String,
			default: 'none',
			validator (value) {
				// The value must match one of these strings or be empty
				const sizes = ['none', 'xsmall', 'small', 'medium', 'large', 'xlarge'];
				return sizes.includes(value);
			}
		},
		// Set the background colour of the card
		color: {
			type: String,
			default: ''
		},
		// Sets a border radius of 2.1rem
		round: {
			type: Boolean,
			default: true
		},
		border: {
			type: Boolean,
			default: true
		},
		// Set the box shadow
		elevation: {
			type: [String, Number],
			default: 0,
			validator (value) {
				if (value === 0) {
					return true;
				}
				// The value must match one of these strings or be empty
				const sizes = ['elevation-1', 'elevation-2', 'elevation-3'];
				return sizes.includes(`elevation-${value}`);
			}
		},
		// shrink:{
		//  type: Boolean,
		//  default: false
		// },
		// Sets the the width of the card
		width: {
			type: String,
			default: '',
			validator (value) {
				// The value must match one of these strings or be empty
				if (value === '') {
					return true;
				}
				const sizes = ['quarterWidth', 'thirdWidth', 'halfWidth', 'twoThirdWidth', 'threeQuarterWidth', 'fullWidth'];
				return sizes.includes(`${value}Width`);
			}
		}
	}
};
</script>

<style scoped>
.card.border{
  border:.1rem solid #e6e8ed
}
.card{
  display:flex;
  flex-direction:column
}
@media (min-width:992px){
  .card.quarterWidth{
    flex:1 1 25%;
    max-width:calc(25% - 2rem)
  }
  .card.thirdWidth{
    flex:1 1 33.33%;
    max-width:calc(33.33% - 2rem)
  }
  .card.halfWidth{
    flex-basis:50%;
    max-width:calc(50% - 2rem)
  }
  .card.twoThirdWidth{
    flex:1 1 66.66%;
    max-width:calc(66.66% - 2rem)
  }
  .card.threeQuarterWidth{
    flex-basis:75%;
    max-width:calc(75% - 2rem)
  }
  .card.fullWidth{
    flex-basis:100%;
    max-width:100%
  }
}
.card.round{
  border-radius:.9rem
}
.card.round>:first-child{
  border-top-left-radius:.9rem;
  border-top-right-radius:.9rem
}
.card.round>:last-child{
  border-bottom-left-radius:.9rem;
  border-bottom-right-radius:.9rem
}
.card>*{
  background-color:#fff;
  width:100%
}
</style>
